import React, { useEffect } from 'react';
import * as d3 from 'd3';
import { rounder } from '@lib/helpers';
const stateColorsWheel = {
  onGoing: ['#666666', '#e5e5e5'],
  enough: ['#C2C923', '#e5e5e5'],
  current: ['#1C2743', '#e5e5e5'],
  zero: ['#e5e5e5'],
};

const ProjectDonutChart = ({ chartId, data, current, progress }) => {
  const plotData = [];

  Object.keys(data).forEach((key) => {
    if (key !== 'total' && key !== 'threshold' && data[key] !== 0) {
      plotData.push(data[key]);
    }
  });

  useEffect(() => {
    let colors = current
      ? stateColorsWheel['current']
      : data.done === 0
      ? stateColorsWheel['zero']
      : data.done >= data.threshold
      ? stateColorsWheel['enough']
      : stateColorsWheel['onGoing']; //colorsWheel[chartId];//colorbrewer(plotData.length);

    /*
      let sizes = {
        innerRadius: 75,
        outerRadius: 100
      };*/

    let sizes = {
      innerRadius: 80,
      outerRadius: 100,
    };

    let durations = {
      entryAnimation: 2000,
    };

    d3.select(`#${chartId}`).html('');

    let generator = d3.pie().padAngle(0.04).sort(null);

    let chart = generator(plotData);

    let arcs = d3
      .select(`#${chartId}`)
      .append('g')
      .attr('transform', 'translate(100, 100)')
      .selectAll('path')
      .data(chart)
      .enter()
      .append('path')
      .style('fill', (d, i) => colors[i])
      .attr('data-value', (d, i) => d.data)
      .attr('data-label', (d, i) => {
        const label = Object.keys(data).find((key) => data[key] === d.data);
        return label;
      });

    let g = d3.select(`#${chartId}`).selectAll('g');

    g.append('text')
      .attr('text-anchor', 'middle')
      .attr('font-size', '2em')
      .attr('y', 12)
      .attr('font-weight', 'bold')
      .text(rounder(data.done) + '%'); //number in circle

    let angleInterpolation = d3.interpolate(generator.startAngle()(), generator.endAngle()());

    let innerRadiusInterpolation = d3.interpolate(0, sizes.innerRadius);
    let outerRadiusInterpolation = d3.interpolate(0, sizes.outerRadius);

    let arc = d3.arc();

    arcs
      .transition()
      .duration(durations.entryAnimation)
      .attrTween('d', (d) => {
        let originalEnd = d.endAngle;
        return (t) => {
          let currentAngle = angleInterpolation(t);
          if (currentAngle < d.startAngle) {
            return '';
          }

          d.endAngle = Math.min(currentAngle, originalEnd);

          return arc(d);
        };
      });

    d3.select(`#${chartId}`)
      .transition()
      .duration(durations.entryAnimation)
      .tween('arcRadii', () => {
        return (t) =>
          arc.innerRadius(innerRadiusInterpolation(t)).outerRadius(outerRadiusInterpolation(t));
      })
      .on('end', () => {
        //console.log(InvestmentChartIcon)
        //d3.select(`#${chartId}`).node().append()
      });

    const tooltip = d3
      .select('body')
      .append('div')
      .attr('class', 'svg-tooltip')
      .attr('class', 'mt-5')
      .style('position', 'absolute')
      .style('visibility', 'hidden');

    const mouseEnterCallback = (d) => {
      d3.select(d.target).attr('stroke-width', '2').attr('stroke', d.target.style.fill);

      /* tooltip.style('visibility', 'visible').text(
        `${propTrans({
          prop: d.target.attributes['data-label'].value,
          scope: 'dashboard',
        })} ${rounder(d.target.attributes['data-value'].value)}`
      ); */
      tooltip.style('visibility', 'visible').text(
        `${d.target.attributes['data-label'].value} ${rounder(
          // d.target.attributes['data-value'].value
          data.done === 0 ? data.done : d.target.attributes['data-value'].value
        )}%`
      );
    };

    const mouseLeaveCallback = (d) => {
      d3.select(d.target).attr('stroke-width', '0');
      tooltip.style('visibility', 'hidden');
    };

    d3.select(`#${chartId}`)
      .selectAll('path')
      .on('mouseenter', mouseEnterCallback)
      .on('mousemove', (event) => {
        tooltip.style('top', `${event.pageY}px`).style('left', `${event.pageX + 10}px`);
      })
      .on('mouseleave', mouseLeaveCallback);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [progress]);

  return (
    <div>
      <svg id={chartId} preserveAspectRatio='xMinYMin meet' viewBox='0 0 200 200'></svg>
    </div>
  );
};

export default ProjectDonutChart;
